<template>
    <div>

        <!-- Tabs and struct -->

        <enac-custom-atpl-assessment-edit-struct :id="id" :toastr-id="toastrId" :bus="bus" :endpoint="endpoint" :endpoint-params="endpointParams"
            :behavioural-indicators-index-id="behaviouralIndicatorsIndexId" 
            :general-criterias-index-id="generalCriteriasIndexId" :item-types-data="itemTypesData" :title="title" drag="1"
            :assessment-type="assessmentType" :learning-unit-id="learningUnitId">
        </enac-custom-atpl-assessment-edit-struct>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-ui-struct-item-form :id="id+'-edit'" :toastr-id="toastrId" :bus="bus" :endpoint="endpoint">
            </trax-ui-struct-item-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            toastrId: {default: 'enac-custom-atpl-assessment-toastr'},
            generalCriteriasIndexId: null,
            behaviouralIndicatorsIndexId: null,
            itemTypesData: null,
            learningUnitId: null,
            assessmentType: null,
            title: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/assessment-items',
                endpointParams: {
                    filters: {
                        learning_unit_id: this.learningUnitId,
                        assessment_type: this.assessmentType
                    },
                    sort: ['order']
                },
                bus: this.$bus
            }
        }
    }
</script>
